/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_TournamentsInputs */



/**
* | output |
* | --- |
* | "Tournaments" |
*
* @param {Nav_TournamentsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_tournaments = /** @type {((inputs?: Nav_TournamentsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_TournamentsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Turniere")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournois")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("赛事")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("賽事")
	if (locale === "ko") return /** @type {LocalizedString} */ ("대회")
	return /** @type {LocalizedString} */ ("Tournaments")
});